import { render, staticRenderFns } from "./ModalContentPostEdit.vue?vue&type=template&id=bab83d6c&"
import script from "./ModalContentPostEdit.vue?vue&type=script&lang=js&"
export * from "./ModalContentPostEdit.vue?vue&type=script&lang=js&"
import style0 from "./ModalContentPostEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports